// src/components/Gallery.jsx
import React, { useState } from 'react';

const Gallery = () => {
    const [activeFilter, setActiveFilter] = useState('all');

    // Sample gallery items (in a real app, these would come from an API or CMS)
    const galleryItems = [
        { id: 1, category: 'exterior', imageUrl: '/images/placeholder-exterior.jpg', alt: 'Exterior detailing' },
        { id: 2, category: 'interior', imageUrl: '/images/placeholder-interior.jpg', alt: 'Interior detailing' },
        { id: 3, category: 'exterior', imageUrl: '/images/placeholder-exterior2.jpg', alt: 'Exterior waxing' },
        { id: 4, category: 'interior', imageUrl: '/images/placeholder-interior2.jpg', alt: 'Leather treatment' },
        { id: 5, category: 'full', imageUrl: '/images/placeholder-full.jpg', alt: 'Full detail' },
        { id: 6, category: 'full', imageUrl: '/images/placeholder-full2.jpg', alt: 'Complete restoration' }
    ];

    const filters = [
        { id: 'all', label: 'All Work' },
        { id: 'exterior', label: 'Exterior' },
        { id: 'interior', label: 'Interior' },
        { id: 'full', label: 'Full Detail' }
    ];

    const filteredItems = activeFilter === 'all'
        ? galleryItems
        : galleryItems.filter(item => item.category === activeFilter);

    return (
        <section id="gallery" className="gallery section">
            <div className="container">
                <div className="section-header">
                    <h2 className="section-title">Why Choose Wade Bros</h2>
                    <p className="section-subtitle">You didn’t invest in your car to watch it lose its shine.<br/><br/>
                        We know your life moves fast. Between meetings, errands, and family time — who has a spare afternoon for drop-off and pickup at the car wash? <br/><br/>
                        That’s why Wade Bros Mobile Auto Detailing was built: to bring your car back to showroom condition, without wasting a second of your time. Our fully equipped detailing pros come to you, armed with precision, passion, and the latest eco-friendly tech.
                        </p>
                </div>

                <div className="gallery-filters">
                    {filters.map(filter => (
                        <button
                            key={filter.id}
                            className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
                            onClick={() => setActiveFilter(filter.id)}
                        >
                            {filter.label}
                        </button>
                    ))}
                </div>

                <div className="gallery-grid">
                    {filteredItems.map(item => (
                        <div key={item.id} className="gallery-item">
                            <img src={item.imageUrl} alt={item.alt} className="gallery-image" />
                            <div className="gallery-overlay">
                                <div className="overlay-content">
                                    <h3>{item.alt}</h3>
                                    <p>{item.category.toUpperCase()} DETAILING</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Gallery;